import { RefObject, useEffect, useRef } from 'react';

// A no-op OverlayView whose only purpose is to expose getProjection(), so the
// draw hooks can convert between container pixels and lng/lat.
const useProjectionOverlay = (
  map: google.maps.Map | null,
): RefObject<google.maps.OverlayView | null> => {
  const projectionOverlayRef = useRef<google.maps.OverlayView | null>(null);

  useEffect(() => {
    if (!map) {
      return undefined;
    }
    const overlay = new google.maps.OverlayView();
    overlay.onAdd = () => {};
    overlay.draw = () => {};
    overlay.onRemove = () => {};
    overlay.setMap(map);
    projectionOverlayRef.current = overlay;
    return () => {
      overlay.setMap(null);
      projectionOverlayRef.current = null;
    };
  }, [map]);

  return projectionOverlayRef;
};

export default useProjectionOverlay;
